/**
 * @file LocaleContext.tsx
 * @description Locale context provider for managing language state
 * @module contexts/LocaleContext
 */

'use client';

import { createContext, useContext, ReactNode } from 'react';

type Locale = 'pl' | 'en' | 'de' | 'cs' | 'sk' | 'uk';

interface LocaleContextType {
  locale: Locale;
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined);

export function useLocale() {
  const context = useContext(LocaleContext);
  if (!context) {
    throw new Error('useLocale must be used within LocaleProvider');
  }
  return context;
}

interface LocaleProviderProps {
  children: ReactNode;
  locale?: Locale;
}

export function LocaleProvider({ children, locale = 'pl' }: LocaleProviderProps) {
  return (
    <LocaleContext.Provider value={{ locale }}>
      {children}
    </LocaleContext.Provider>
  );
}
